module.exports = __webpack_public_path__ + "static/media/fa-brands-400.03783c51.eot";